import { AnchorHTMLAttributes, ReactElement, ReactNode, useMemo } from "react";
import { findFirstComponentOfType } from "../internal/TextExtractor";

interface AuthActionAnchorProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
    children?: ReactNode;
    defaultLabel: string;
    title: string;
    onAction: () => void;
}

/**
 * Anchor used by the session actions.
 * The visible label is the children of `arg-label`. Omitted slot uses `defaultLabel`.
 * Text outside `arg-label` is ignored. href, role, class, click, and title are set after
 * authored attributes so an authored onclick cannot replace the action or navigate.
 */
export function AuthActionAnchor({
    children,
    className,
    defaultLabel,
    title,
    onAction,
    ...anchorProps
}: AuthActionAnchorProps): ReactElement {
    const labelChild = useMemo(() => findFirstComponentOfType(children, "arg-label"), [children]);
    const label = labelChild ? labelChild.props.children : defaultLabel;

    return (
        <a
            {...anchorProps}
            href="/"
            role="button"
            className={className}
            onClick={(event) => {
                event.preventDefault();
                onAction();
            }}
            title={title}
        >
            {label}
        </a>
    );
}
